<template>
	<div class="search-login-info">
		<div class="el-search vue-top-padding radius">
			<el-row :gutter="20">
				<el-col :span="6">
					<div class="el-left">
						<el-button
							type="danger"
							size="small"
							v-hasPerm="['login:info:delete']"
							icon="el-icon-delete"
							:disabled="multipleSelection.length <= 0"
							@click="delBatchLoginInfo"
							>{{ $t("common.delete") }}</el-button
						>
					</div>
				</el-col>
				<el-col :span="18">
					<div class="el-right">
						<el-form
							ref="loginInfo"
							:model="loginInfo"
							:inline="true"
							label-width="10px"
							size="small"
							class="demo-form-inline el-input-height"
						>
							<el-form-item prop="locale">
								<el-input
									v-model="loginInfo.locale"
									:placeholder="$t('searchLoginInfo.pLoginLocation')"
								></el-input>
							</el-form-item>
							<el-form-item>
								<el-date-picker
									v-model="dateTime"
									type="datetimerange"
									format="yyyy-MM-dd HH:mm:ss"
									value-format="yyyy-MM-dd HH:mm:ss"
									range-separator="-"
									:picker-options="pickerOptions"
									:start-placeholder="$t('searchLoginInfo.startTime')"
									:end-placeholder="$t('searchLoginInfo.endTime')"
								>
								</el-date-picker>
							</el-form-item>
							<el-form-item prop="userName">
								<el-input
									v-model="loginInfo.userName"
									:placeholder="$t('searchLoginInfo.pUsername')"
								></el-input>
							</el-form-item>
							<el-form-item prop="enabled">
								<el-select
									v-model="loginInfo.state"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									clearable
									:placeholder="$t('searchLoginInfo.selectStatus')"
								>
									<el-option
										:label="$t('searchLoginInfo.success')"
										value="0"
									></el-option>
									<el-option
										:label="$t('searchLoginInfo.error')"
										value="1"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									@click="onSubmit"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									@click="resetSearch('loginInfo')"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchLoginInfo",
	props: {
		loginInfo: Object,
		multipleSelection: Array,
	},
	data() {
		return {
			dateTime: "",
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
		};
	},
	methods: {
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.loginInfo.startTime = this.dateTime[0];
				this.loginInfo.endTime = this.dateTime[1];
			}
			this.$emit("onSubmit");
		},

		resetSearch(formName) {
			this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			this.$toolUtil.clearForm(this.loginInfo);
			this.dateTime = "";
			this.$emit("resetSearch");
		},

		// 删除登录日志
		delBatchLoginInfo() {
			this.$confirm(this.$t("searchLoginInfo.isDel"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.LoginInfo.delete, this.$method.delete, {
						ids: this.$cloud.getIds(this.multipleSelection),
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: this.$t("searchLoginInfo.delS"),
								type: "success",
							});
							this.$emit("update");
						}
					});
			});
		},
	},
};
</script>

<style scoped></style>
